// extracted by mini-css-extract-plugin
export default {"coverLink":"IQ-z","contentBox":"JQ-z","zapposPromoContainer":"KQ-z","zapposPromoGroupContainer":"LQ-z","promos":"MQ-z","bottom":"NQ-z","top":"OQ-z","right":"PQ-z","left":"QQ-z"};